import { GridSortItem } from "@mui/x-data-grid";
import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { UserPaginationFiltersForQuery } from "Interfaces/UserFilters";

export interface IUserState {
  searchText: string;
  pageIndex: number;
  pageNumber: number;
  pageSize: number;
  total: number;
  sort: GridSortItem[];
  sortForRelatives: GridSortItem[];
  filters: UserPaginationFiltersForQuery;
  nif: string;
}

const initialState: IUserState = {
  searchText: "",
  pageIndex: 0,
  pageNumber: 0,
  pageSize: 10,
  total: 0,
  sort: [
    {
      field: "name",
      sort: "asc",
    },
  ],
  sortForRelatives: [
    {
      field: "createdAt",
      sort: "asc",
    },
  ],
  filters: { },
  nif: "",
};

export const userSlice = createSlice({
  initialState,
  name: "userSlice",
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setSort: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sort = action.payload;
    },
    setNif: (state, action: PayloadAction<string>) => {
      state.nif = action.payload;
    },
    updateFilters: (
      state,
      action: PayloadAction<UserPaginationFiltersForQuery>
    ) => {
      console.log("updateFilters", action.payload);
      
      state.filters =action.payload;
      
    },
    removeCurrentFilters: (state, action: PayloadAction<string>) => {
      console.log("removeCurrentFilters action", action);
      
      console.log("removeCurrentFilters", action.payload);
      
      let filtersWithRemovedCode: UserPaginationFiltersForQuery = {
        ...current(state).filters,
      };
      delete filtersWithRemovedCode[
        action.payload as keyof UserPaginationFiltersForQuery
      ];
      state.filters = filtersWithRemovedCode;
    },
  },
});

export default userSlice.reducer;

export const {
  setSearchText,
  setPageIndex,
  setPageSize,
  setTotal,
  setSort,
  setNif,
  updateFilters,
  removeCurrentFilters,
} = userSlice.actions;
